// extracted by mini-css-extract-plugin
module.exports = {" _key":"sitepen-site/NewsLetter","copy":"NewsLetter-m__copy__f52bc31e9KV","iframe":"NewsLetter-m__iframe__f52bc31wpmu"};